import pbx from './lib/FreePBX.js'
module.exports = pbx;
